import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'


const BookmarkJob = props => {

  //make fetch call to api inside of componentDidMount
  //upon successful call, render home page with flash message
  const x = (
    <React.Fragment>
      <div>something</div>
    </React.Fragment>
  )
  return (
    <div>
      {x}
    </div>


  )
}


export default BookmarkJob



// WEBPACK FOOTER //
// ./src/home/BookmarkJob.js